import { BrandColors } from '../theme';

export const toastTokens = {
    root: {
        borderRadius: '8px',
        borderWidth: '1px',
        width:'468px'
    },
    content: {
        padding: '0.75rem 1rem',
        gap: '0.75rem',
    },
    info: {
        background: BrandColors.primary[50],
        borderColor: BrandColors.primary[100],
        color: BrandColors.primary[900],
        detailColor: BrandColors.primary[800],
    },
    success: {
        background: BrandColors.green[50],
        borderColor: BrandColors.green[200],
        color: BrandColors.green[800],
        detailColor: BrandColors.green[900],
    },
    warn: {
        background: BrandColors.yellow[50],
        borderColor: BrandColors.yellow[200],
        color: BrandColors.yellow[700],
        detailColor: BrandColors.yellow[800],
    },
    error: {
        background: BrandColors.red[50],
        borderColor: BrandColors.red[100],
        color: BrandColors.red[900],
        detailColor: BrandColors.red[800],
    },
};
